<template>
  <div id='position-list' v-if='postitionList'>
    <div class='section-title'>{{ $t(`playerLineup.${postitionList.label}`)  }}</div>
    <div id='position-list-player-list'>
      <playerItem v-for='(item, index) in postitionList.list' :key="item[1]" :player='item' :class="(postitionList.list.length > 2) && ((index + 1) / 2 <= rowCount - 1) ? 'divider' : ''"/>
    </div>
  </div>
</template>

<script>
import playerItem from './playerItem'

export default {
  name: 'position-list',
  props: {
    postitionList: {
      type: Object,
      // required: true,
      default: () => {
        return {
          label: 2,
          list: [
            {
              playerId: 24,
              jerseyNumber: 23,
              playerName: '安东尼·戴维斯'
            },
            {
              playerId: 0,
              jerseyNumber: 12,
              playerName: '凯尔·库兹马'
            },
            {
              playerId: 37,
              jerseyNumber: 456,
              playerName: '科斯塔斯·阿德托'
            }
          ]
        }
      }
    }
  },
  components: {
    playerItem
  },
  computed: {
    rowCount: function () {
      return Math.ceil(this.postitionList.list.length / 2)
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~@/styles'

#position-list-player-list
  display: flex
  flex-wrap: wrap

.divider
  border-bottom: 1px solid #dcdcdc
</style>
